<div id="general">
  <div class="card">
    <div class="card-header border-bottom mb-1">
      <h2 class="card-title">
        {{ "GENERAL.BILLING_ADDRESS.TITLE" | translate }}
      </h2>
      <button
        rippleEffect
        type="button"
        (click)="toggleSocietyModal()"
        class="btn btn-primary"
      >
        {{ "GENERAL.BILLING_ADDRESS.BUTTON" | translate }}
      </button>
    </div>

    <div class="card-body d-flex">
      <div class="w-100 d-flex">
        <div class="w-100">
          <p class="d-flex mb-2">
            <strong class="w-25"
              >{{ "GENERAL.BILLING_ADDRESS.COMPANY" | translate }}:</strong
            >
            <span class="w-75">{{ society.name }}</span>
          </p>
          <!-- <p class="d-flex ml-1">
            <strong class="w-50"
              >{{
                "GENERAL.BILLING_ADDRESS.BILLING_EMAIL" | translate
              }}:</strong
            >
            <span class="w-50">itsupport.company@gmail.com</span>
          </p>
          <p class="d-flex ml-1">
            <strong class="w-50"
              >{{ "GENERAL.BILLING_ADDRESS.TAX_ID" | translate }}:</strong
            >
            <span class="w-50">TAX-875623</span>
          </p>
          <p class="d-flex ml-1">
            <strong class="w-50"
              >{{ "GENERAL.BILLING_ADDRESS.VAT_NUMBER" | translate }}:</strong
            >
            <span class="w-50">SDF754K77</span>
          </p> -->
          <p class="d-flex mb-2">
            <strong class="w-25"
              >{{
                "GENERAL.BILLING_ADDRESS.BILLING_ADDRESS" | translate
              }}:</strong
            >
            <span class="w-75"
              >{{ society.street }}<br>{{ society.postal_code + ' ' + society.city }}</span
            >
          </p>
          <!-- </div>
      </div>

      <div class="w-50 d-flex ml-1">
        <div class="w-100"> -->
          <!-- <p class="d-flex">
            <strong class="w-50"
              >{{ "GENERAL.BILLING_ADDRESS.CONTACT" | translate }}:</strong
            >
            <span class="w-50">+1 (609) 933-44-22</span>
          </p> -->
          <p class="d-flex mb-2">
            <strong class="w-25"
              >{{ "GENERAL.BILLING_ADDRESS.COUNTRY" | translate }}:</strong
            >
            <span class="w-75">France</span>
          </p>
          <!-- <p class="d-flex">
            <strong class="w-50"
              >{{ "GENERAL.BILLING_ADDRESS.STATE" | translate }}:</strong
            >
            <span class="w-50">Île-de-France</span>
          </p>
          <p class="d-flex">
            <strong class="w-50"
              >{{ "GENERAL.BILLING_ADDRESS.ZIP_CODE" | translate }}:</strong
            >
            <span class="w-50">92600</span>
          </p> -->
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-header border-bottom mb-1">
      <h2 class="card-title">{{ "GENERAL.CURRENT_PLAN.TITLE" | translate }}</h2>
    </div>
    <div class="card-body">
      <form class="validate-form">
        <div class="row">
          <div class="col-6">
            <div class="current-plan--text">
              <p class="mb-0">
                {{ "GENERAL.CURRENT_PLAN.PLAN.TEXT" | translate }}
              </p>
              <p class="mb-4">
                {{ "GENERAL.CURRENT_PLAN.PLAN.SUBTEXT" | translate }}
              </p>
            </div>

            <div class="current-plan--text">
              <p class="mb-0">
                {{ "GENERAL.CURRENT_PLAN.EXPIRATION.TEXT" | translate }} Dec 09,
                2021
              </p>
              <p>
                {{ "GENERAL.CURRENT_PLAN.EXPIRATION.SUBTEXT" | translate }}
              </p>
            </div>

            <!-- <div class="current-plan--text">
              <p class="mb-0">
                {{ "GENERAL.CURRENT_PLAN.PRICE.TEXT" | translate }}
              </p>
              <p class="mb-1">
                {{ "GENERAL.CURRENT_PLAN.PRICE.SUBTEXT" | translate }}
                <span class="badge badge-primary-transparent text-primary">{{
                  "GENERAL.CURRENT_PLAN.PRICE.BADGE" | translate
                }}</span>
              </p>
            </div> -->
          </div>
          <div class="col-6">
            <!-- <ngb-alert [type]="'warning'" [dismissible]="false">
              <h4 class="alert-heading">
                {{ "GENERAL.CURRENT_PLAN.WARNING.TITLE" | translate }}
              </h4>
              <div class="alert-body">
                {{ "GENERAL.CURRENT_PLAN.WARNING.TEXT" | translate }}
              </div>
            </ngb-alert> -->

            <div class="d-flex justify-content-between">
              <p class="font-weight-bold mb-1">
                {{ "GENERAL.CURRENT_PLAN.PROGRESS.DAYS" | translate }}
              </p>
              <p class="font-weight-bold mb-1">
                4 / 30 {{ "GENERAL.CURRENT_PLAN.PROGRESS.DAYS" | translate }}
              </p>
            </div>

            <div class="progress-wrapper">
              <ngb-progressbar type="primary" [value]="87"></ngb-progressbar>
              <p class="mt-1">
                {{
                  "GENERAL.CURRENT_PLAN.PROGRESS.REQUIRES_UPDATE" | translate
                }}
              </p>
            </div>
          </div>
          <div class="col-12 d-flex justify-content-end">
            <button type="submit" class="btn btn-primary mr-2" rippleEffect>
              {{ "GENERAL.CURRENT_PLAN.UPGRADE_BUTTON" | translate }}
            </button>
            <button type="submit" class="btn btn-outline-danger" rippleEffect>
              {{ "GENERAL.CURRENT_PLAN.CANCEL_BUTTON" | translate }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="card">
    <div class="card-header border-bottom mb-1">
      <h2 class="card-title">
        {{ "GENERAL.PAYMENT_METHODS.TITLE" | translate }}
      </h2>
      <button rippleEffect type="button" class="btn btn-primary">
        <i data-feather="plus"></i
        >{{ "GENERAL.PAYMENT_METHODS.BUTTON" | translate }}
      </button>
    </div>

    <div class="card-body">
      <ng-container *ngIf="paymentCards.length == 0; else displayCards">
        <div>
          <p>{{ "GENERAL.PAYMENT_METHODS.NO_CARDS" | translate }}</p>
        </div>
      </ng-container>

      <ng-template class="card mt-1 mb-0 border" #displayCards>
        <div
          *ngFor="let paymentCard of paymentCards; let index = index"
          class="card-body d-flex justify-content-between pb-0"
        >
          <div>
            <img
              class="mb-1"
              [src]="
                'assets/images/icons/payment-methods/' +
                paymentCard.brand +
                '.png'
              "
              alt=""
            />
            <p class="m-0">
              {{ paymentCard.owner }}
              <span
                *ngIf="paymentCard.isPrimary"
                class="badge badge-primary-transparent text-primary"
                >{{
                  "GENERAL.PAYMENT_METHODS.CARDS.BADGES.PRIMARY" | translate
                }}</span
              >
            </p>
            <p>{{ paymentCard.cardNumber }}</p>
          </div>

          <div>
            <div class="btn-group-sm mb-2">
              <button rippleEffect class="btn btn-outline-primary py-1">
                {{ "GENERAL.PAYMENT_METHODS.CARDS.EDIT_BUTTON" | translate }}
              </button>
              <button
                rippleEffect
                class="btn btn-link text-primary"
                (click)="removePaymentCard(paymentCard.id)"
              >
                {{ "GENERAL.PAYMENT_METHODS.CARDS.DELETE_BUTTON" | translate }}
              </button>
            </div>
            <p>
              {{ "GENERAL.PAYMENT_METHODS.CARDS.EXPIRES_AT" | translate }}
              {{ paymentCard.expirationDate }}
            </p>
          </div>
        </div>
      </ng-template>
    </div>
  </div>

  <div
    *ngIf="showSocietyModal"
    class="society-modal position-fixed w-100 h-100 modal"
    [ngClass]="{
      show: showSocietyModal,
      'custom-fade-out': fadeoutSocietyModal
    }"
    role="dialog"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form
          class="validate-form"
          [formGroup]="editSocietyDetails"
          (ngSubmit)="updateSocietyDetails()"
        >
          <div class="modal-header bg-white">
            <button
              type="button"
              class="close"
              (click)="toggleSocietyModal()"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body mx-2">
            <h3 class="user-modal--title">
              {{ "SOCIETY_INFORMATION.TITLE" | translate }}
            </h3>

            <div class="form-row d-flex justify-content-between m-0">
              <div class="form-group col-6 mr-n1 pr-1">
                <label for="society">{{
                  "SOCIETY_INFORMATION.SOCIETY" | translate
                }}</label>
                <input
                  type="text"
                  name="society"
                  id="society"
                  class="form-control"
                  [placeholder]="
                    'SOCIETY_INFORMATION.DEFAULT_SOCIETY' | translate
                  "
                  formControlName="name"
                />
                <small *ngIf="formErrors['name']" class="text-danger">{{
                  "SOCIETY_INFORMATION.ERROR" | translate
                }}</small>
              </div>

              <!-- <div class="form-group col-6 mr-n1 pr-1">
                <label for="country">{{
                  "SOCIETY_INFORMATION.COUNTRY" | translate
                }}</label>
                <input
                  type="text"
                  name="country"
                  id="country"
                  class="form-control"
                  [placeholder]="
                    'SOCIETY_INFORMATION.DEFAULT_COUNTRY' | translate
                  "
                  formControlName="country"
                />
                <small *ngIf="formErrors['country']" class="text-danger">{{
                  "SOCIETY_INFORMATION.ERROR" | translate
                }}</small>
              </div> -->
              <div class="form-group col-6 mr-n1 pr-1">
                <label for="city">{{
                  "SOCIETY_INFORMATION.CITY" | translate
                }}</label>
                <input
                  type="text"
                  name="city"
                  id="city"
                  class="form-control"
                  [placeholder]="
                    'SOCIETY_INFORMATION.DEFAULT_CITY' | translate
                  "
                  formControlName="city"
                />
                <small *ngIf="formErrors['city']" class="text-danger">{{
                  "SOCIETY_INFORMATION.ERROR" | translate
                }}</small>
              </div>
            </div>

            <div class="form-row d-flex justify-content-between m-0">
              <div class="form-group col-6 mr-n1 pr-1">
                <label for="street">{{
                  "SOCIETY_INFORMATION.STREET" | translate
                }}</label>
                <input
                  type="text"
                  name="street"
                  id="street"
                  class="form-control"
                  [placeholder]="
                    'SOCIETY_INFORMATION.DEFAULT_STREET' | translate
                  "
                  formControlName="street"
                />
                <small *ngIf="formErrors['street']" class="text-danger">{{
                  "SOCIETY_INFORMATION.ERROR" | translate
                }}</small>
              </div>

              <div class="form-group col-6 mr-n1 pr-1">
                <label for="street">{{
                  "SOCIETY_INFORMATION.STREET2" | translate
                }}</label>
                <input
                  type="text"
                  name="street2"
                  id="street2"
                  class="form-control"
                  [placeholder]="
                    'SOCIETY_INFORMATION.DEFAULT_STREET2' | translate
                  "
                  formControlName="street2"
                />
                <small *ngIf="formErrors['street2']" class="text-danger">{{
                  "SOCIETY_INFORMATION.ERROR" | translate
                }}</small>
              </div>
            </div>

            <div class="form-row d-flex justify-content-between m-0">
              <div class="form-group col-6 mr-n1 pr-1">
                <label for="postal_code">{{
                  "SOCIETY_INFORMATION.ZIPCODE" | translate
                }}</label>
                <input
                  type="text"
                  name="postal_code"
                  id="postal_code"
                  class="form-control"
                  [placeholder]="
                    'SOCIETY_INFORMATION.DEFAULT_ZIPCODE' | translate
                  "
                  formControlName="postal_code"
                />
                <small *ngIf="formErrors['postal_code']" class="text-danger">{{
                  "SOCIETY_INFORMATION.ERROR" | translate
                }}</small>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-center border-0">
            <button
              type="button"
              class="btn btn-outline-primary mr-1"
              data-dismiss="modal"
              (click)="toggleSocietyModal()"
            >
              {{ "SOCIETY_INFORMATION.CANCEL_BUTTON" | translate }}
            </button>
            <button class="btn btn-primary" [disabled]="modalLoadingButton">
              <span
                *ngIf="modalLoadingButton"
                class="spinner-border spinner-border-sm mr-1"
              ></span
              >{{ "SOCIETY_INFORMATION.EDIT_BUTTON" | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
    <div (click)="toggleSocietyModal()" class="modal-backdrop"></div>
  </div>
</div>
